import React from 'react';
import { Helmet } from 'react-helmet-async';
import { seoConfig } from '../../../data/seoConfig';

interface SEOProps {
  title?: string;
  description?: string;
  path?: string;
}

const SEO: React.FC<SEOProps> = ({ title, description, path = '' }) => {
  const siteUrl = 'https://itmonkeys.fr'; // Remplacez par votre URL
  const fullUrl = `${siteUrl}${path}`;
  
  return (
    <Helmet>
      <title>{title || seoConfig.home.title}</title>
      <meta name="description" content={description || seoConfig.home.description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title || seoConfig.home.title} />
      <meta property="og:description" content={description || seoConfig.home.description} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title || seoConfig.home.title} />
      <meta name="twitter:description" content={description || seoConfig.home.description} />
      
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEO; 